"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _definitionhelpers = require("../../../utils/definitionhelpers");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// utils

/* ++++++++++ --------------- BAR CHART : DEFINITION --------------- ++++++++++ */


var _default = {
  name: 'BarChart',
  group: _definitionhelpers.groupNames.charts,
  props: {
    type: {
      type: 'string',
      default: 'percentage',
      options: ['percentage'],
      description: 'This bar chart will render based on percentages that should equal 100, we can refactor code and add different types in the future'
    },
    height: {
      type: 'string',
      default: '150px',
      description: 'Height will be set to 150px, it can be overridden using this prop'
    },
    width: {
      type: 'string',
      default: null,
      description: 'Width will be set to 150px, it can be overridden using this prop'
    },
    data: {
      type: 'object',
      default: [{
        y: 100,
        color: 'rgb(255, 207, 0)',
        x: 'Pending'
      }, {
        y: 40,
        x: 'Complete',
        color: 'rgb(20, 148, 244)'
      }, {
        y: 1,
        x: 'Delayed',
        color: 'rgb(223, 29, 29)' // {
        //     y: 20,
        //     x: 'Testing123',
        //     color: 'rgb(20, 123, 124)'
        // },
        // {
        //     y: 30,
        //     x: 'Hello World',
        //     color: 'rgb(223, 100, 29)'
        // }

      }]
    }
  }
};
exports.default = _default;